import AxiosClient from "../AxiosClient";

// 市況価格表使用店舗情報取得Api
export const postMarketPriceShopUsingSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/marketPriceShopUsing/searchInfoList", params);
}
